export const AgentLineCopyurl = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      height="16.995"
      width="16.995"
      rx="3.54063"
      stroke="currentColor"
      strokeWidth="1.41625"
      x="2.00391"
      y="5.00195"
    />
    <path
      d="M6 5.49762V5.32949C6 3.48797 7.49285 1.99512 9.33438 1.99512H18.6706C20.5122 1.99512 22.005 3.48797 22.005 5.32949V14.6657C22.005 16.5073 20.5122 18.0001 18.6706 18.0001H18.5025"
      stroke="currentColor"
      strokeWidth="1.33375"
    />
    <path
      d="M9.34375 11.7691L11.6771 9.34009C12.3171 8.70006 13.3689 8.71417 14.0263 9.37157C14.6837 10.029 14.6978 11.0807 14.0578 11.7207L13.2156 12.6125"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.41625"
    />
    <path
      d="M7.14942 14.2539C6.92444 14.4789 6.45922 14.9281 6.45922 14.9281C5.81918 15.5681 5.80181 16.7089 6.45922 17.3663C7.11662 18.0237 8.16834 18.0377 8.80838 17.3978L11.0852 15.3307"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.41625"
    />
    <path
      d="M9.43991 14.0708C9.13456 13.7655 8.96799 13.375 8.94132 12.9803C8.91055 12.5252 9.06569 12.0644 9.40844 11.7217"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.41625"
    />
    <path
      d="M11.0547 12.9824C11.7121 13.6398 11.7262 14.6916 11.0862 15.3316"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.41625"
    />
  </svg>
);
